var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container common-list-page" }, [
    _c(
      "div",
      [
        _c("el-row"),
        _vm._v(" "),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              {
                staticStyle: { "padding-top": "160px" },
                attrs: { span: 12, offset: "6" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { type: "primary" },
                    on: { click: _vm.userActive },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("voyagePlanSearch.unsubscribe")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }